import { render } from "./ErrorProveedorTecnologico.vue?vue&type=template&id=7c91ef78"
import script from "./ErrorProveedorTecnologico.vue?vue&type=script&lang=js"
export * from "./ErrorProveedorTecnologico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__